import { Input } from 'antd';
import React from 'react';

export const numberMask = (value) =>
  value
    .replace(/\D/g,"") //Remove tudo o que não é dígito
    .replace(/^(\d{2})(\d)/g,"($1) $2") //Coloca parênteses em volta dos dois primeiros dígitos
    .replace(/(\d)(\d{4})$/,"$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

export function InputPhone({
  className,
  value,
  onChange,
  disabled,
  placeholder,
  prefix,
}){

  function handleChange(e) {
    const { value: phone } = e.target;
    onChange(numberMask(phone));
  }

  return (
    <Input
      autoComplete="off"
      maxLength={15}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      prefix={prefix}
      className={className}
    />
  );

}
